<template>
  <!-- 遮罩层 -->
  <div class="mask-wrap" v-if="dialogVisible" @click.self="closeDialog">
    <!-- 弹窗主体 -->
    <div class="standard-dialog">
      <!-- 弹窗标题栏 -->
      <div class="dialog-header">
        <h3>标准详情</h3>
        <span class="close-btn" @click="closeDialog">×</span>
      </div>
      <!-- 弹窗内容区域（原标准卡片） -->
      <div class="dialog-body">
        <div class="standard-detail-card">
          <!-- 顶部标准号区域 -->
          <div class="standard-top">
            <span class="standard-code">标准号：{{ sourceData.standardNumber || '' }}</span>
            <span class="tag-cai">采</span>
          </div>

          <!-- 基础信息文本 -->
          <div class="info-line">
            <span class="label">中文标准名称：</span>
            <span class="text">{{ sourceData.csName || '' }}</span>
          </div>
          <div class="info-line">
            <span class="label">英文标准名称：</span>
            <span class="text">{{ sourceData.esName || '' }}</span>
          </div>
          <div class="info-line">
            <span class="label">标准状态：</span>
            <span class="text status-normal">{{ sourceData.standardState || '' }}</span>
          </div>

          <!-- 版权提示文字 -->
          <!-- <p class="copyright-tip">该标准采用了ISO、IEC等国际国外组织的标准，由于涉及版权保护问题，本系统暂不提供在线阅读服务。</p> -->

          <!-- 分割虚线 -->
          <div class="dash-line"></div>

          <!-- 两栏信息网格 -->
          <div class="grid-row">
            <div class="grid-col">
              <span class="grid-label">中国标准分类号 (CCS)</span>
              <span class="grid-value">{{ sourceData.ccs || '' }}</span>
            </div>
            <div class="grid-col">
              <span class="grid-label">国际标准分类号 (ICS)</span>
              <span class="grid-value">{{ sourceData.ics || '' }}</span>
            </div>
          </div>
          <div class="grid-row">
            <div class="grid-col">
              <span class="grid-label">发布日期</span>
              <span class="grid-value">{{ sourceData.releaseDate || '' }}</span>
            </div>
            <div class="grid-col">
              <span class="grid-label">实施日期</span>
              <span class="grid-value">{{ sourceData.implementationDate || '' }}</span>
            </div>
          </div>
          <div class="grid-row">
            <div class="grid-col">
              <span class="grid-label">主管部门</span>
              <span class="grid-value">{{ sourceData.zgbm || '' }}</span>
            </div>
            <div class="grid-col">
              <span class="grid-label">归口部门</span>
              <span class="grid-value">{{ sourceData.gkbm || '' }}</span>
            </div>
          </div>
          <div class="grid-row single-col">
            <div class="grid-col full">
              <span class="grid-label">发布单位</span>
              <span class="grid-value">{{ sourceData.fbdw || '' }}</span>
            </div>
          </div>
          <div class="grid-row single-col last-row">
            <div class="grid-col full">
              <span class="grid-label">备注</span>
              <span class="grid-value">{{ sourceData.remark || '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StandardDetailDialog",
  props: {
    // 弹窗显示控制 .sync 修饰符 vue2 语法
    dialogVisible: {
      type: Boolean,
      default: false
    },
    sourceData: {
      type: Object,
      required: true, // 强制必须传
      // 默认空对象兜底
      default: () => ({})
    }
  },
  methods: {
    closeDialog() {
      // 关闭弹窗，同步父组件变量
      this.$emit("update:dialogVisible", false);
      this.$emit("close");
    }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.mask-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}
/* 弹窗外层容器 */
.standard-dialog {
  width: 100%;
  max-width: 1200px;
  max-height: 90vh;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* 弹窗头部 */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}
.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}
.close-btn {
  font-size: 24px;
  color: #909399;
  cursor: pointer;
}
.close-btn:hover {
  color: #f56c6c;
}
/* 弹窗滚动内容区 */
.dialog-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* ---------------- 原标准卡片样式 --------------- */
.standard-detail-card {
  width: 100%;
  border: 1px solid #c6e0f5;
  background: linear-gradient(to bottom, #ffffff, #f0f7ff);
  padding: 32px 40px;
  box-sizing: border-box;
}

/* 顶部标准号+采标签 */
.standard-top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}
.standard-code {
  font-size: 28px;
  color: #b32424;
  font-weight: bold;
}
.tag-cai {
  width: 36px;
  height: 36px;
  background-color: #f9cc6c;
  color: #915a00;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

/* 单行基础信息 */
.info-line {
  font-size: 16px;
  margin: 12px 0;
  line-height: 1.6;
}
.label {
  color: #222;
  font-weight: 500;
}
.text {
  color: #111;
}
.status-normal {
  color: #007020;
  font-weight: 500;
}

/* 版权红色提示文字 */
.copyright-tip {
  font-size: 16px;
  color: #a82626;
  margin: 24px 0;
  line-height: 1.7;
}

/* 虚线分割线 */
.dash-line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #cccccc;
  margin-bottom: 28px;
}

/* 网格行布局 */
.grid-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #e8edf2;
}
.grid-row.single-col {
  grid-template-columns: 100%;
}
.grid-row.last-row {
  border-bottom: none;
}
.grid-col {
  display: flex;
  align-items: center;
  padding: 18px 0;
}
.grid-col.full {
  width: 100%;
}
.grid-label {
  width: 180px;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
}
.grid-value {
  font-size: 16px;
  color: #222;
}
</style>